import { useRef, useEffect } from 'react'

import useHandleSocketMessage from './useHandleSocketMessage'

const useMaintainSocketConnection = ({ socketURL }) => {
  const socketMessageHandlers = useHandleSocketMessage()

  const socket = useRef(null)
  const timeoutID = useRef(null)

  const closeConnection = () => {
    timeoutID.current = null
    socket.current?.close()
    socket.current = null
  }

  const createSocket = (url) => {
    const _socket = new WebSocket(url)
    _socket.addEventListener('open', () => {
    })
    _socket.addEventListener('close', () => {
        if (timeoutID.current === null) {
          timeoutID.current = setTimeout(openConnection, 1000)
        }
    })
    _socket.addEventListener('error', (error) => {
      console.error(error)
    })
    _socket.addEventListener('message', ({ data: messageDataString }) => {
      const messageData = JSON.parse(messageDataString)
      const { service, event, ...props } = messageData || {}
      if (!service) return

      if (typeof socketMessageHandlers?.[service] === 'function') {
        socketMessageHandlers[service]({ ...props })
      }
      if (typeof socketMessageHandlers?.[service]?.[event] === 'function') {
        socketMessageHandlers?.[service]?.[event]({ ...props })
      }
    })

    return _socket
  }

  const openConnection = () => {
    timeoutID.current = null
    socket.current = createSocket(socketURL)
  }

  const testConnection = (connection, expectedURL) => {
    if (connection === null) return false

    const isReadyStateValid = (
      connection.readyState === WebSocket.OPEN ||
      connection.readyState === WebSocket.CONNECTING
    )

    const isConnectionAlreadyOpen = (
      isReadyStateValid
      && connection.url === expectedURL
    )

    return isConnectionAlreadyOpen
  }

  useEffect(() => {
    if (!socketURL) {
      closeConnection()
      return
    }

    if (testConnection(socket.current, socketURL)) {
      return
    }

    if (socket.current === null) {
      openConnection()
      return
    }
  }, [socketURL])

  return { socket: socket.current }
}

export default useMaintainSocketConnection
